import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ReportDetail() {
  const { period } = useParams();
  const [state, setState] = useState({ kind: "loading" });
  useEffect(() => {
    fetch(`${API}/public/reports/${period}`).then(async r => {
      if (!r.ok) return setState({ kind: "missing" });
      const d = await r.json();
      setState({ kind: "ok", report: d.report });
    }).catch(() => setState({ kind: "missing" }));
  }, [period]);
  if (state.kind === "loading") return <div data-testid="report-loading" className="text-sm text-muted">loading…</div>;
  if (state.kind === "missing") return (
    <section data-testid="report-missing" className="space-y-4">
      <h1 className="hs-display text-3xl md:text-4xl">Report not found</h1>
      <p className="text-muted">No published report exists for <code className="hs-mono">{period}</code>.</p>
      <Link to="/reports" className="hs-link">← Back to reports</Link>
    </section>
  );
  const r = state.report;
  return (
    <section data-testid="report-detail" className="space-y-6">
      <Link to="/reports" className="hs-link text-sm">← All reports</Link>
      <h1 className="hs-display text-3xl md:text-4xl">Report {r.period}</h1>
      <div className="text-xs text-muted">
        generated {r.generated_at?.slice(0, 19)} · published {r.published_at?.slice(0, 19)}
      </div>
      <article data-testid="report-markdown"
               className="hs-markdown max-w-3xl">
        <ReactMarkdown skipHtml>{r.markdown || ""}</ReactMarkdown>
      </article>
    </section>
  );
}
